// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "paper-3-0Fd";
export { _1 as "__esModule", _2 as "paper" }
export default { "__esModule": _1, "paper": _2 }
